const formatPhoneNumberNew = (inputNumber, withCountryCode = false) => {
  let formattedNumber = '';

  if (withCountryCode) {
    formattedNumber = inputNumber
      ?.toString()
      .replace(/(\d{3})(\d{2})(\d{3})(\d{2})(\d{2})/, '$1 $2 $3 $4 $5');
  } else {
    formattedNumber = inputNumber
      ?.toString()
      .replace(/(\d{2})(\d{3})(\d{2})(\d{2})/, '$1 $2 $3 $4');
  }

  return formattedNumber;
};

export default formatPhoneNumberNew;
